import React, {useEffect, useState, useContext} from 'react';
import './TextField.scss'
import DatePicker from "react-datepicker";
import MaskedInput from 'react-text-mask';
import InlineValidation from '../inlineValidation/inlineValidation'
import Required from "../Required";
import {ConfigContext} from '../../screens/form/DynamicForm/DynamicForm'

export const TextField_Custom = ({ fieldId, cssField, label, maxLength = 20, inputType = 'text', fieldIsRequired = true, stateProps, settextGroupID = 0}) => {
  
    const context = useContext(ConfigContext)
    const {formik} = useContext(ConfigContext)
    
    const [fieldIsEmpty, setEmpty] = useState(true)
    const [fieldIsFilled, setFilled] = useState(false)
    const [fieldIsFocused, setFocused] = useState(false)
    const [errorOnField, setFieldError] = useState(false)
    const [errorMessage, setErrorMessage] = useState(stateProps.errorMessage)
    const [fieldValue, setFieldValue] = useState('')
    
    useEffect(() => {
        if (stateProps.error.state && !fieldValue && fieldIsRequired) {
            setFieldError(true)
        }
        else {
            setFieldError(false)
        }
    }, [stateProps.error.state, fieldValue]);

    useEffect(() => {
        stateProps.setEnteredValues({ ...stateProps.enteredValues, textGroupID: settextGroupID });
    }, []);
    
    function emptyTheField() {
      setEmpty(true)
      setFilled(false)
    }
    
    function blurTheField(e, fieldId) {
      setFocused(false); 
      formik.setFieldTouched(fieldId); 
      e.target.value.length === 0 ? emptyTheField() : setFilled(true)
    }

    function onChange(e) {
        setFieldValue(e.target.value)
        stateProps.setEnteredValues({...stateProps.enteredValues, [fieldId]: e.target.value})
    }
  
    return (
      <div className={` form-field text-field ${cssField} ${errorOnField && 'noBottomMargin'} `} id={fieldId} >  
          <div className='text-input' style={{height: errorOnField ? 'auto' : 48}}>
          <div className="label-container">
              <p className='text-label subtitle2'>{label}</p>
              <Required value={fieldIsRequired} />
            </div>
            <input
              {...formik.getFieldProps(fieldId)}
              type={inputType}
              style={{paddingTop: 0}}
              name={fieldId}
              onFocus={() => { setEmpty(false); setFocused(true)}}
              onBlur={(e)=>{blurTheField(e, fieldId)}}
              onChange={(e) => onChange(e)}
              maxLength={maxLength}
              className={ errorOnField && 'error-input' }
            />
              
              {fieldIsEmpty && <EmptyHint label={label} required={fieldIsRequired}/> }
              {(fieldIsFocused || fieldIsFilled) && <FilledHint label={label} required={fieldIsRequired}/> }
          </div>
        
          {errorOnField && <InlineValidation formik={formik} fieldId={fieldId} fieldTouched={fieldIsFilled} customMessage={errorMessage}/>}
      </div>
    )
  }

export default TextField_Custom;

const EmptyHint = ({label, required}) => {
    return (
      <div className='hint empty-hint' style={{ display: 'flex', position: 'relative', bottom: 30, zIndex: -1, paddingLeft: 13 }} >
        <p className='subtitle2' style={{whiteSpace:"nowrap"}}>{label}</p>
      </div>
    )
  }
  
  const FilledHint = ({label}) => {
    return (
      <div className='hint filled-hint overline' style={{ display: 'flex', position: 'relative', bottom: 30, marginBottom:16, fontSize: 12, paddingLeft: 13, textTransform: 'uppercase', }} >
      </div>
    )
  }